import { render, staticRenderFns } from "./AccountCircle.vue?vue&type=template&id=3157b0b0&scoped=true"
var script = {}
import style0 from "./AccountCircle.vue?vue&type=style&index=0&id=3157b0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157b0b0",
  null
  
)

export default component.exports